import { SVGProps } from "react";

interface ChevronIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
  direction?: "up" | "down" | "left" | "right";
}

export default function ChevronIcon({
  size = 16,
  className = "",
  direction = "down",
  ...props
}: ChevronIconProps) {
  // Determine rotation based on direction
  const getRotation = () => {
    switch (direction) {
      case "up":
        return "rotate-180";
      case "left":
        return "rotate-90";
      case "right":
        return "-rotate-90";
      case "down":
      default:
        return "rotate-0";
    }
  };

  const rotationClass = getRotation();
  const combinedClassName = `transition-transform duration-200 ease-in-out ${rotationClass} ${className}`;

  return (
    <svg
      width={size}
      height={size}
      className={combinedClassName}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 9l-7 7-7-7"
      />
    </svg>
  );
}
